export const MENUS_CONFIG = [
	{
		icon: 'search',
		title: 'Select Site',
		url: '/sites'
	},
	{
		icon: 'people',
		title: 'Current Labor',
		tabIndex: '0',
		url: '/current-labor'
	},
	{
		icon: 'directions_bus',
		title: 'Unit Availability',
		tabIndex: '1',
		url: 'unit-availability'
	},
	{
		icon: 'notifications',
		title: 'CSI Events',
		tabIndex: '2',
		url: 'csi-events'
	},
	{
		icon: 'mail',
		title: 'Report An Issue',
		url: 'report-issue'
	},
	{
		icon: 'exit_to_app',
		title: 'Logout',
		url: 'logout'
	}
]